import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/logo-light.svg'


const _hoisted_1 = { id: "public-document-column" }
const _hoisted_2 = { id: "public-document-content" }

import { BButton } from 'bootstrap-vue-next';

export default /*@__PURE__*/_defineComponent({
  __name: 'PublicDocument',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_RouterLink, { to: "/" }, {
      default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
        _createElementVNode("img", {
          src: _imports_0,
          class: "logo",
          alt: "Sampling Human"
        }, null, -1)
      ]))]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _createVNode(_unref(BButton), {
      variant: "outline-light",
      size: "sm",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/')))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_font_awesome_icon, {
          icon: "angle-left",
          class: "me-2"
        }),
        _cache[2] || (_cache[2] = _createTextVNode(" Back to Home ", -1))
      ]),
      _: 1
    })
  ]))
}
}

})